import React, { useState, useEffect } from 'react';
import styles from './styles.module.css';
import QRCOde from 'qrcode.react';
import { useSelector, useDispatch } from 'react-redux';
import { checkInBtn, whiteCloseIcon } from 'assets/newIcons';
import { Box, Drawer } from '@material-ui/core';

const boxStyle = {
  height: '100vh',
  padding: '60px 20px 0px 10px',
  backgroundImage: 'linear-gradient(180deg, #ff5000 62.5%, rgba(254, 80, 0, 0.68) 100%)',
};

export default function CheckInQR() {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const qrCodeDetails = useSelector(state => state?.homePageNew?.qrCodeDetails);
  const dispatch = useDispatch();
  const [codeForQr, setCodeForQr] = useState(qrCodeDetails?.data);
  const caId = useSelector(state => state?.auth?.profile?.userID);
  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  useEffect(() => {
    setCodeForQr(qrCodeDetails?.data);
  }, [qrCodeDetails]);

  useEffect(() => {
    let intervalId;
    if (caId && isDrawerOpen) {
      const fetchQrCode = () => {
        dispatch({
          type: 'LOAD_QR_CODE_REQUEST',
          caId,
        });
      };
      fetchQrCode(); // Initial call
      intervalId = setInterval(fetchQrCode, 5000);
    }
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [caId, dispatch, isDrawerOpen]);

  return (
    <div>
      <img
        alt=""
        src={checkInBtn}
        onClick={() => toggleDrawer()}
        className={styles.fixedButton}
      />
      <Drawer anchor="bottom" open={isDrawerOpen} onClose={() => toggleDrawer()}>
        <Box sx={boxStyle}>
          <div className={styles.imgContainer}>
            <img
              alt=""
              onClick={() => toggleDrawer()}
              className={styles.closeIcon}
              src={whiteCloseIcon}
            />
          </div>
          {qrCodeDetails && Object.keys(qrCodeDetails).length > 0 ? (
            codeForQr ? (
              <div className={styles.content}>
                <p>
                  Scan this QR Code at the front <br /> desk to check-in.
                </p>
                {codeForQr && (
                  <div className={styles.codeSection}>
                    <QRCOde className={styles.code} value={codeForQr} size={166} />
                  </div>
                )}
                <b>
                  Have a great <br /> workout!
                </b>
              </div>
            ) : (
              <div className={styles.content}>
                <p>{qrCodeDetails?.message}</p>
              </div>
            )
          ) : (
            <div className={styles.content}>
              <p>Loading...</p>
            </div>
          )}
        </Box>
      </Drawer>
    </div>
  );
}
